const csvTemplate = `outlet_code,is_active
F2F-00002-02SL0001255,FALSE
VST-00004-AFO2504001,FALSE
F2F-00002-A-0015,TRUE`;

export default csvTemplate;
